import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

interface RefreshIconProps extends SvgIconProps {
    width?: number;
    height?: number;
}

const RefreshIcon: React.FC<RefreshIconProps> = ({ width = 28, height = 28, ...props }) => (
    <SvgIcon
        {...props}
        viewBox="0 0 28 28"
        sx={{ width, height, ...props.sx }}
    >
        <path
            fill='currentColor'
            d="M14 6a8 8 0 0 0-7.88 6.59l-.98-.18a9 9 0 0 1 17.66-.28l1.28-1.9.84.55-2.3 3.41-3.4-2.27.56-.84 2.07 1.4A8 8 0 0 0 14 6Zm-8.62 7.8 3.4 2.28-.56.84-2.08-1.4a8 8 0 0 0 15.74-.1l.98.17a9 9 0 0 1-17.66.28l-1.28 1.9-.84-.55 2.3-3.41Z"
        />
    </SvgIcon>
);

export default RefreshIcon;